export default function HeroSection() {
  const handleScroll = (id: string) => {
    const el = document.querySelector(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section
      id="hero"
      className="relative w-full min-h-[580px] md:min-h-[680px] flex items-center overflow-hidden bg-background-50"
    >
      <div className="absolute inset-0 overflow-hidden">
        <img
          src="https://readdy.ai/api/search-image?query=Dark%20cinematic%20abstract%20composition%20with%20flowing%20warm%20orange%20and%20deep%20black%20gradients%20dynamic%20stage%20lighting%20effects%20geometric%20shapes%20floating%20in%20space%20modern%20minimalist%20entertainment%20poster%20aesthetic%20soft%20glowing%20particles%20luxurious%20theater%20atmosphere%20stylized%20abstract%20art%20with%20rich%20texture%20and%20depth%20professional%20broadcast%20design&width=1800&height=900&seq=hero-bg-6080-01&orientation=landscape"
          alt="6080影视综艺娱乐背景"
          className="w-full h-full object-cover object-center opacity-50"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-background-50/80 via-background-50/50 to-background-50"></div>
        <div className="absolute inset-0 bg-gradient-to-r from-background-50/90 via-background-50/40 to-transparent"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-8 py-16 md:py-20">
        <div className="max-w-[1280px] mx-auto flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-primary-500/15 border border-primary-500/25 mb-5">
              <i className="ri-fire-line text-primary-400 text-sm"></i>
              <span className="text-xs font-medium text-primary-400 whitespace-nowrap">综艺大全 · 高清免费 · 流畅不卡</span>
            </div>

            <h1 className="font-heading font-bold text-3xl md:text-4xl lg:text-5xl text-foreground-50 leading-tight mb-4">
              6080影视 - 综艺节目高清免费在线观看
            </h1>

            <p className="text-lg md:text-xl text-foreground-300 font-heading mb-6">
              追最新综艺，看最热节目，一个网站就够了
            </p>

            <p className="text-sm md:text-base text-foreground-500 leading-relaxed mb-6 max-w-xl lg:max-w-none">
              6080影视专注综艺节目高清在线播放，覆盖热门综艺、搞笑综艺、真人秀、音乐节目等全类型内容。
              同步各大卫视与网络平台最新档期，高清画质流畅不缓冲，免注册免会员即点即看。
              无论是最新一期的《奔跑吧》《歌手》，还是经典回顾《极限挑战》《向往的生活》，这里都为你一网打尽。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 mb-8">
              <div className="text-center">
                <div className="text-xl md:text-2xl font-bold text-accent-400 font-heading">10000+</div>
                <div className="text-xs text-foreground-600 mt-0.5">小时综艺内容</div>
              </div>
              <div className="w-px h-10 bg-background-400/40 hidden sm:block"></div>
              <div className="text-center">
                <div className="text-xl md:text-2xl font-bold text-accent-400 font-heading">日更30+</div>
                <div className="text-xs text-foreground-600 mt-0.5">档热门节目</div>
              </div>
              <div className="w-px h-10 bg-background-400/40 hidden sm:block"></div>
              <div className="text-center">
                <div className="text-xl md:text-2xl font-bold text-accent-400 font-heading">99.9%</div>
                <div className="text-xs text-foreground-600 mt-0.5">流畅播放率</div>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <button
                onClick={() => handleScroll('#index')}
                className="whitespace-nowrap px-8 py-3 bg-primary-500 hover:bg-primary-600 text-background-50 font-medium rounded-lg transition-all duration-200 text-sm cursor-pointer w-full sm:w-auto"
              >
                <i className="ri-play-circle-line mr-1.5"></i>立即观看
              </button>
              <button
                onClick={() => handleScroll('#topics')}
                className="whitespace-nowrap px-8 py-3 bg-background-200/70 hover:bg-background-300/60 text-foreground-200 font-medium rounded-lg border border-background-400/30 transition-all duration-200 text-sm cursor-pointer w-full sm:w-auto"
              >
                <i className="ri-fire-line mr-1.5"></i>热门综艺
              </button>
            </div>
          </div>

          <div className="flex-1 w-full max-w-[480px] lg:max-w-[520px]">
            <div className="relative aspect-[4/3] rounded-xl overflow-hidden bg-background-100/80 border border-background-300/20">
              <img
                src="https://readdy.ai/api/search-image?query=Vibrant%20abstract%20stage%20performance%20with%20flowing%20colorful%20ribbons%20of%20warm%20orange%20amber%20and%20coral%20tones%20modern%20minimalist%20variety%20show%20visual%20dynamic%20motion%20blur%20effects%20spotlight%20beams%20cutting%20through%20dark%20space%20entertainment%20and%20music%20atmosphere%20elegant%20stylized%20broadcast%20graphics%20with%20soft%20glow%20and%20particles&width=1040&height=780&seq=hero-visual-6080-02&orientation=landscape"
                alt="6080影视综艺节目主视觉"
                className="w-full h-full object-cover object-center"
              />
              <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-background-50/90 to-transparent h-24"></div>
              <div className="absolute bottom-4 left-4 flex items-center gap-3">
                <span className="w-10 h-10 rounded-full bg-primary-500/90 flex items-center justify-center">
                  <i className="ri-play-fill text-background-50 text-lg"></i>
                </span>
                <span className="text-xs text-foreground-300 font-medium">热门综艺 · 即刻畅享</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}